import todo from "../assets/images/todo.png";
import plants from "../assets/images/plants.png";
import river from "../assets/images/river.png";
import netflix from "../assets/images/netflix.png";
import mbti from "../assets/images/mbti.png";
import social from "../assets/images/social.png";

export const portfolio = [
  {
    id: 1,
    name: "To Do List",
    image: todo,
    code: "https://github.com/lolaaskerova/todo_list",
    live: "https://todolistbylolaaskerova.netlify.app/",
  },
  {
    id: 2,
    name: "Plants",
    image: plants,
    code: "https://github.com/lolaaskerova/plants",
    live: "https://plantsbylolaaskerova.netlify.app/",
  },
  {
    id: 3,
    name: "River Rafting",
    image: river,
    code: "https://github.com/lolaaskerova/river_rafting",
  },
  {
    id: 4,
    name: "Netflix",
    image: netflix,
    code: "https://github.com/lolaaskerova/netflix_clone",
    live: "https://netflixbylolaaskerova.vercel.app/",
  },
  {
    id: 5,
    name: "Personality Test",
    image: mbti,
    live: "https://personalitytest.io/",
  },
  {
    id: 6,
    name: "Social Scheduler",
    image: social,
    live: "https://socialscheduler.so/",
  },
];
